var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReflectVertical = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 10C2 9.58437 2.33437 9.25 2.75 9.25H17.25C17.6656 9.25 18 9.58437 18 10C18 10.4156 17.6656 10.75 17.25 10.75H2.75C2.33437 10.75 2 10.4156 2 10ZM7.20625 16.5H12.7906L10 13.7063L7.20625 16.5ZM6 18C5.59687 18 5.23125 17.7563 5.075 17.3813C4.91875 17.0063 5.00625 16.5781 5.29063 16.2906L9.29063 12.2906C9.68125 11.9 10.3156 11.9 10.7063 12.2906L14.7063 16.2906C14.9938 16.5781 15.0781 17.0063 14.9219 17.3813C14.7656 17.7563 14.4031 18 13.9969 18H5.99688H6ZM10 6.29375L12.7937 3.5H7.20625L10 6.29375ZM5.075 2.61875C5.23125 2.24375 5.59687 2 6 2H14C14.4031 2 14.7688 2.24375 14.925 2.61875C15.0813 2.99375 14.9938 3.42188 14.7094 3.70938L10.7094 7.70937C10.3188 8.1 9.68437 8.1 9.29375 7.70937L5.29375 3.70938C5.00625 3.42188 4.92188 2.99375 5.07812 2.61875H5.075Z",
  fill: "#F8F9FA"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgReflectVertical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "b046aaa40850da6f04ec1b3eb9070d69.svg";